import Vue from 'vue'
import Router from 'vue-router'
import ServicePage from '@/pages/ServicePage'
import ServiceSettingsPage from '@/pages/ServiceSettingsPage'
import Display from '@/pages/Display'
import GeneralSettingsPage from '@/pages/GeneralSettingsPage'
import QueuesSettingsPage from '@/pages/QueuesSettingsPage'
import ListDevicesPage from '@/pages/ListDevicesPage'
import ListServicesPage from '@/pages/ListServicesPage'
import OperatorsSettingsPage from '@/pages/OperatorsSettingsPage.vue'
import ServiceEntryPage from '@/pages/ServiceEntryPage'
import AdminPage from '@/pages/AdminPage'
import store from '@/store'
import ChooseServicePage from '@/pages/ChooseServicePage'
import ListAdminsPage from '@/pages/ListAdminsPage'
import PausedTicketsPage from '@/pages/PausedTicketsPage'
import io from 'socket.io-client'
import Layout from '@/layouts/Layout.vue'
import UnauthorizedPage from '@/pages/UnauthorizedPage'
import ListNotifiersPage from '@/pages/ListNotifiersPage'

Vue.use(Router)

const loadServices = async (to, from, next) => {
  await store.dispatch('fetchProfile')
  await store.dispatch('fetchServices')
  next()
}

const router = new Router({
  mode: 'history',
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/unauthorized',
      name: 'UnauthorizedPage',
      component: UnauthorizedPage
    },
    {
      path: '/',
      component: Layout,
      beforeEnter: loadServices,
      children: [
        {
          path: '/admin',
          name: 'AdminPage',
          component: AdminPage,
          meta: {
            twoFactor: ['u2f']
          },
          beforeEnter: async (to, from, next) => {
            await store.dispatch('clearServiceContext')
            next()
          }
        },
        {
          path: '',
          name: 'ChooseServicePage',
          component: ChooseServicePage,
          beforeEnter: async (to, from, next) => {
            await store.dispatch('clearServiceContext')
            next()
          }
        },
        {
          path: '/admins',
          name: 'ListAdminsPage',
          component: ListAdminsPage,
          beforeEnter: async (to, from, next) => {
            await store.dispatch('clearServiceContext')
            next()
          }
        },
        {
          path: '/services',
          name: 'ListServicesPage',
          component: ListServicesPage,
          beforeEnter: async (to, from, next) => {
            await store.dispatch('clearServiceContext')
            next()
          }
        },
        {
          path: '/notifiers',
          name: 'ListNotifiersPage',
          component: ListNotifiersPage,
          beforeEnter: async (to, from, next) => {
            await store.dispatch('clearServiceContext')
            next()
          }
        },
        {
          path: '/devices',
          name: 'ListDevicesPage',
          component: ListDevicesPage,
          beforeEnter: async (to, from, next) => {
            await store.dispatch('clearServiceContext')
            next()
          },
          props: route => {
            return {
              status: route.query.status,
              serviceID: route.query.serviceID
            }
          }
        },
        {
          path: '/services/:serviceID',
          component: ServiceEntryPage,
          redirect: { name: 'ServicePage' },
          props: route => {
            return {
              serviceID: route.params.serviceID
            }
          },
          children: [
            {
              path: 'queues',
              name: 'ServicePage',
              component: ServicePage,
              props: route => {
                return {
                  serviceID: route.params.serviceID,
                  socket: io('', { transports: ['websocket'] })
                }
              }
            },
            {
              path: 'settings',
              name: 'ServiceSettingsPage',
              component: ServiceSettingsPage,
              props: route => {
                return {
                  serviceID: route.params.serviceID
                }
              }
            },
            {
              path: 'settings/general',
              name: 'GeneralSettingsPage',
              component: GeneralSettingsPage,
              props: route => {
                return {
                  serviceID: route.params.serviceID,
                  socket: io('', { transports: ['websocket'] })
                }
              }
            },
            {
              path: 'settings/queue-management/',
              name: 'QueuesSettingsPage',
              component: QueuesSettingsPage,
              props: route => {
                return {
                  serviceID: route.params.serviceID
                }
              }
            },
            {
              path: 'settings/device-management/',
              name: 'DevicesSettingsPage',
              component: ListDevicesPage,
              props: route => {
                return {
                  serviceID: route.params.serviceID
                }
              }
            },
            {
              path: 'settings/operator-management/',
              name: 'OperatorsSettingsPage',
              component: OperatorsSettingsPage,
              props: route => {
                return {
                  serviceID: route.params.serviceID
                }
              }
            },
            {
              path: 'paused-tickets',
              name: 'PausedTicketsPage',
              component: PausedTicketsPage,
              props: route => {
                return {
                  serviceID: route.params.serviceID
                }
              }
            }
          ]
        }
      ]
    },
    {
      path: '/display/:service/:token?',
      component: Display,
      props: route => {
        return {
          serviceID: route.params.service,
          token: route.params.token,
          socket: io(`?token=${route.params.token}`, {
            transports: ['websocket']
          })
        }
      },
      beforeEnter: async (to, from, next) => {
        await store.dispatch('fetchCurrentTickets', to.params.service)
        next()
      }
    }
  ]
})

export default router
